/**
 * Footer Accordion
 */

const Footer = () => {
  const footer = document.querySelector('footer');
  const accordionFooter = document.querySelector('footer.footer-accordion'); // Footer with accordion class

  if (footer) {
    const footerNavParents = footer.querySelectorAll('.menu-item-has-children > a[href="#"]');
    footerNavParents.forEach((link) => {
      link.setAttribute('aria-expanded', 'false');
      link.setAttribute('tabindex', '0');
			link.addEventListener('keydown', keydownHandler);
    });
    if (accordionFooter) {
      footerNavParents.forEach((link) => {
        link.addEventListener('click', clickHandler);
      });
    }
  }

  /**
   * Opens and closes the accodion menus.
   *
   * @param event click event
   */
  function clickHandler(event) {
		// console.log(event.target);
    event.preventDefault(); // Prevent href
    // event.target.toggleAttribute('aria-expanded', 'true');
		event.target.setAttribute('aria-expanded', `${!(event.target.getAttribute('aria-expanded') === 'true')}`);
    event.target.parentElement.classList.toggle('open');
  }

  /**
   * Prevents activating with the enter key.
   *
   * @param {KeyboardEvent} event
   */
  function keydownHandler(event) {
    // The action button is activated by space on the keyup event, but the
    // default action for space is already triggered on keydown. It needs to be
    // prevented to stop scrolling the page before activating the button.
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }
};

export default Footer;
